import React, { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { sharedApi } from "@/lib/api";

export default function NewsletterBand() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email address");
      return;
    }
    try {
      setLoading(true);
      await sharedApi.post("/classifieds/newsletter", {
        email: email.trim(),
        country: "NZ",
        source: "web_home",
      });
      toast.success("You're on the list — kia ora!");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't subscribe — try again in a moment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="rounded-2xl bg-[color:var(--brand-blue-wash)] p-8 md:p-12 grid md:grid-cols-2 gap-6 items-center">
        <div>
          <h2 className="font-display text-2xl md:text-3xl font-extrabold text-slate-900 leading-tight">
            Subscribe to Our Newsletter!
          </h2>
          <p className="mt-2 text-sm md:text-base text-slate-600 leading-relaxed">
            Stay up to date with our latest news, product launches, and exclusive offers!
          </p>
        </div>
        <form onSubmit={submit} className="flex flex-col sm:flex-row items-stretch gap-2">
          <div className="relative flex-1">
            <Mail className="w-4 h-4 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2" />
            <input
              data-testid="newsletter-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.co.nz"
              className="w-full pl-11 pr-4 py-3 rounded-full bg-white border border-white focus:border-[color:var(--brand-blue)] focus:outline-none text-sm"
            />
          </div>
          <button
            type="submit"
            data-testid="newsletter-submit"
            className="rounded-full bg-[color:var(--brand-orange)] hover:bg-[color:var(--brand-orange-hover)] text-white font-bold px-6 py-3 transition-colors whitespace-nowrap"
          >
            Subscribe Now
          </button>
        </form>
      </div>
    </section>
  );
}
